<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        :persistent="true"
        width="85%"
        height="100%"
        class="modalDialog"
        no-click-animation
    >
      <div>
        <v-card class="cardWrap">
          <CardTitle title="ポイント履歴" />
          <v-card-actions class="pointHistory">
            <div class="pointHistory__memberNo">
              会員番号
              <span class="modalDataTable__info__inner">{{ member_no }}</span>
            </div>
            <br />
            <div class="pointHistory__totalpoint">
              <span class="modalDataTable__info__inner">ポイント残高{{ point_total }} pt</span>
              <span class="modalDataTable__info__inner">獲得予定{{ expected_total }} pt</span>
            </div>
          </v-card-actions>
          <v-card-actions height="80px" class="cardWrap__scroll">
            <v-data-table
              class="modalDataTable"
              dense
              :headers="headers"
              :items="desserts"
              hide-default-footer
              id="osusume"
              height="350px"
              width="20px"
              sort-by="membersNumber"
              :class="getColor(desserts.point)"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-select
                    class="mr-3"
                    :items="golfCourseSearchComputed"
                    item-value="golf_code"
                    item-text="golf_name"
                    v-model="golf_courses_val"
                    label="ゴルフ場を選択"
                    hide-details
                    width="100px"
                  ></v-select>
                  <v-select
                    class="mr-3"
                    :items="point_types"
                    item-value="id"
                    item-text="point_type_display"
                    v-model="point_types_val"
                    label="区分を選択"
                    hide-details
                    width="100px"
                  ></v-select>
                  <v-btn
                    :disabled="btn[1].isActive"
                    color="primary"
                    class="ml-5"
                    v-on:click="search">検索</v-btn>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
                <template v-slot:[`item.point`]="{ item }">
                    <div :class="getColor(item.point)" >{{ item.point }}</div>
                </template>
            </v-data-table>
          </v-card-actions>
          <v-card-actions class="pointHistory">
            <v-pagination
              class="my-2"
              v-model="page"
              :length="pageCount"
              :total-visible="7"
              @input="clickPagination"
            ></v-pagination>
          </v-card-actions>
          <v-overlay :value="overlay">
              <template>
                <v-row justify="center">
                    <v-dialog v-model="dialog" :persistent='true' width="50%" height="50%" class="modalDialog" no-click-animation>
                    <div class="memberAdd">
                        <v-card class="cardWrap">
                        <CardTitle title="ポイント登録" />
                        <v-card-actions class="cardWrap__scroll">
                            <v-container>
                                <v-form class="cardWrap__fromArea" ref="form" v-model="valid">
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">発生日</div>
                                            <v-text-field
                                                maxlength="10"
                                                inputmode="tel"
                                                type="tel"
                                                id="form_select"
                                                placeholder="0000-00-00"
                                                @focus="focusDate(add_processing_date)"
                                                @input="add_processing_date = $event"
                                                :value="formatedDate(add_processing_date)"
                                                @keyup.delete="deleteKeyUpProcDate($event)"
                                                @keyup="add_processing_date = formatDate(add_processing_date)"
                                                :rules="[actionrules.required,
                                                        actionrules.string_type,
                                                        actionrules.format_date,
                                                        actionrules.CorrectDate]"
                                                ></v-text-field>
                                    </v-row>
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">ゴルフコース</div>
                                            <v-select
                                                class="mr-3"
                                                :items="golfCourseListComputed"
                                                item-value="golf_code"
                                                item-text="golf_name"
                                                v-model="add_golf_courses"
                                                placeholder="ゴルフコース"
                                                :rules="[actionrules.required,]"
                                            ></v-select>
                                    </v-row>
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">区分</div>
                                            <v-select
                                                class="mr-3"
                                                :items="add_point_types"
                                                item-value="id"
                                                item-text="point_type_display"
                                                v-model="add_select_point_types"
                                                placeholder="区分"
                                                :rules="[actionrules.required,]"
                                                v-on:change="pointTypeSelectDisabled"
                                            ></v-select>
                                    </v-row>
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">種類</div>
                                            <v-select
                                                class="mr-3"
                                                :items="limited_type"
                                                item-value="code"
                                                item-text="code_name"
                                                v-model="add_limited_type"
                                                placeholder="種類"
                                                :rules="[actionrules.checkTypelimited,]"
                                                v-on:change="pointTypeSelectDisabled"
                                                :disabled="limited_type_disabled"
                                            ></v-select>
                                    </v-row>
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">詳細内容</div>
                                            <v-text-field
                                                v-model="add_action"
                                                placeholder="詳細内容"
                                                :rules="[actionrules.required,
                                                actionrules.limit]"
                                            ></v-text-field>
                                    </v-row>
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">ポイント</div>
                                            <v-text-field
                                                v-model="add_point_value"
                                                placeholder="ポイント数"
                                                :rules="[actionrules.required,
                                                actionrules.pointrules,
                                                actionrules.pointleadrules]"
                                            ></v-text-field>
                                    </v-row>
                                    <v-row>
                                        <div class="cardWrap__fromArea__title">有効期限</div>
                                            <v-text-field
                                                maxlength="10"
                                                inputmode="tel"
                                                type="tel"
                                                placeholder="0000-00-00"
                                                @focus="focusDate(add_valid_start)"
                                                @input="add_valid_start = $event"
                                                :value="formatedDate(add_valid_start)"
                                                @keyup.delete="deleteKeyUpValidStart($event)"
                                                @keyup="add_valid_start = formatDate(add_valid_start)"
                                                :rules="[
                                                    actionrules.string_type,
                                                    actionrules.format_date,
                                                    actionrules.CorrectDate,
                                                    actionrules.CorrectTypeStartDate
                                                ]"
                                                :disabled="valid_start_disabled"
                                            ></v-text-field>
                                        <div class="table_space">～</div>
                                            <v-text-field
                                                placeholder="0000-00-00"
                                                maxlength="10"
                                                inputmode="tel"
                                                type="tel"
                                                @focus="focusDate(add_valid_date)"
                                                @input="add_valid_date = $event"
                                                :value="formatedDate(add_valid_date)"
                                                @keyup.delete="deleteKeyUpValidDate($event)"
                                                @keyup="add_valid_date = formatDate(add_valid_date)"
                                                :rules="[
                                                    actionrules.string_type,
                                                    actionrules.format_date,
                                                    actionrules.CorrectDate,
                                                    actionrules.CorrectEndDate,
                                                    actionrules.CorrectTypeEndDate
                                                ]"
                                                :disabled="valid_date_disabled"
                                            ></v-text-field>
                                    </v-row>
                                    <v-row justify="space-around">
                                        <div class="cardWrap__fromArea__title">コメント</div>
                                            <v-text-field
                                                v-model="add_comment"
                                                placeholder="コメント"
                                                :rules="[actionrules.limit]"
                                            ></v-text-field>
                                    </v-row>
                                </v-form>
                            </v-container>
                            </v-card-actions>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                    <v-btn color="green darken-4" text @click="CloseAddModal">戻る</v-btn>
                                    <v-btn color="blue  darken-4" text @click="addPoint">登録</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </div>
                            </v-dialog>
                            </v-row>
                            </template>
                        </v-overlay>
                <v-card-actions>
                <v-spacer></v-spacer>
            <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
            <v-btn
                :disabled="btn[2].isActive"
                v-if="member_rank===1"
                color="blue darken-4"
                text
                @click="formSet">追加</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '../../../components/module/CardTitle';
import validater from '../../../lib/validater';
// mixins
import { utilityMixin } from '@/mixins/utility';
import { authorityMixin } from '@/views/authorityMixin';
// graghql
import {
    GET_GOLFGROUP,
    GET_GOLFCOURSE,
    GET_POINT_LIST,
    GET_POINT_TOTAL_FROM_MEMBER_POINT_HISTORY
} from '../../../constants/member_point_history';
import {
    REGISTER_POINT
} from '../../../constants/point_register';
import { GET_CODE_LIST } from '../../../constants/codelist';
import { GET_POINT_TYPE } from '@/constants/master';

export default {
    components: {
        CardTitle
    },
    mixins: [
        utilityMixin,
        authorityMixin
    ],
    props: [
        'adminInfo',
        'golfGroupInfo',
        'golfCourseInput'
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            page_title: 'ポイント履歴参照',
            // 会員カード追加用ポップアップ表示に関する制御値
            addOverlay: false,
            // モーダル画面表示制御値
            dialog: false,
            pointdialog: false,
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '付与日', align: 'center', sortable: false, value: 'processing_date', width: '8%' },
                { text: '所属ゴルフコース(ゴルフ場)', align: 'center', sortable: false, value: 'golf_name', width: '16%' },
                { text: '区分', align: 'center', sortable: false, value: 'point_type_display', width: '9%' },
                { text: '種類', align: 'center', sortable: false, value: 'point_flag_name', width: '8%' },
                { text: '詳細内容', align: 'center', sortable: false, value: 'action', width: '15%' },
                { text: 'ポイント数', align: 'right', sortable: false, value: 'point', width: '7%' },
                { text: '有効期限', align: 'center', sortable: false, value: 'valid_start', width: '8%' },
                { text: '　', align: 'center', sortable: false, value: 'tilde', width: '1%' },
                { text: '　', align: 'center', sortable: false, value: 'valid_date', width: '8%' },
                { text: 'コメント', align: 'center', sortable: false, value: 'comment', width: '20%' }
            ],
            // グループ選択のセレクトエリアの表示値
            golf_groups: [],
            // グループ選択で選択した値
            golf_groups_val: null,
            golf_courses: [],
            golf_courses_val: '',
            golf_select: [],
            golf_search: [],
            actionrules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                required: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any'),
                pointrules: value => /^([1-9]\d*|0)$/.test(value) || this.$t('error.validation.num'),
                pointleadrules: value => /^[1-9]/.test(value) || this.$t('error.validation.required.zero'),
                checkTypelimited: value => this.checkTypelimited(value) || this.$t('error.validation.required.any'),
                limit: value => (!value || value.length < 256) || this.$t('error.validation.length.detail'),
                CorrectEndDate: value => this.checkstartDate(value) || this.$t('error.validation.date.discrepancy'),
                CorrectTypeStartDate: value => this.checkTypeStartDate(value) || this.$t('error.validation.date.start'),
                CorrectTypeEndDate: value => this.checkTypeEndDate(value) || this.$t('error.validation.date.end'),
                CorrectDate: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            },
            // 区分選択のセレクトエリアの表示値
            point_types: [],
            limited_type: [],
            // 区分選択で選択した値
            point_types_val: null,
            // 画面のモード指定
            modeStatus: '',
            // 表示する会員ID
            member_no: '',
            search_golf_name: [],
            // ポイントの残高
            point_total: 0,
            point_val: 0,
            expected_total: 0,
            golf_courses_disabled: true,
            begin_row: 0,
            processing_date_val: null,
            limit_rows: 10,
            itemsPerPage: 10,
            limited_id: null,
            valid: true,
            valid_start: null,
            valid_date: null,
            valid_flag: null,
            comment: null,
            overlay: false,
            golf_name: null,
            form_display: false,
            add_member_no: '',
            add_golf_groups: null,
            add_golf_courses: '',
            add_processing_date: '',
            add_point_types: [],
            add_select_point_types: null,
            add_action: null,
            add_point: null,
            add_point_value: null,
            add_comment: null,
            add_valid_start: '',
            add_valid_date: '',
            add_limited_id: null,
            golf_code_val: null,
            add_limited_type: null,
            valid_start_disabled: true,
            valid_date_disabled: true,
            limited_type_disabled: true,
            NowDate: null,
            // WEB会員種別（ポイント付与の対象かのフラグ）
            member_rank: 0,
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true }
            ],
            vue_id: 'SCR0007'
        };
    },
    watch: {
        modeStatus () {
            if (this.modeStatus === '') {
                this.page_title = 'ポイント履歴参照';
            } else if (this.modeStatus === 'addpointlist') {
                this.page_title = 'ポイント登録';
            }
        },
        golfCourseListComputed (val) {
            if (val.length === 1) this.add_golf_courses = val[0];
        }
    },
    computed: {
        golfCourseListComputed () {
            // ゴルフ場担当者の場合
            if (this.adminInfo.user_div !== 1) {
                let list = [];
                list.push(this.golf_select.find(el => el.golf_code === this.adminInfo.golf_code));
                return list;
            } else {
            // システム管理者の場合
                return this.golf_select;
            }
        },
        golfCourseSearchComputed () {
            if (this.golfGroupInfo[0].point_use_type === 2) {
                if (this.adminInfo.user_div === '1') {
                    return this.golf_search;
                } else {
                    let list = [];
                    list.push(this.golf_search.find(el => el.golf_code === this.adminInfo.golf_code));
                    return list;
                }
            } else {
                return this.golf_search;
            }
        },
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.member_no = '';
            this.point_total = 0;
            this.point_types_val = '';
            this.addOverlay = false;
            this.point_val = 0;
            this.golf_groups_val = '';
            this.golf_courses_val = '';
            this.golf_search = [];
            this.golf_select = [];
            this.desserts = [];
            this.search_golf_name = [];
            this.golf_courses_disabled = true;
            this.page = 1;
            this.pageCount = 0;
            this.processing_date = null;
            this.limited_id = null;
            this.valid_start = '';
            this.valid_date = '';
            this.valid_flag = null;
            this.comment = null;
            this.golf_name = null;
            this.begin_row = 0;
            this.form_display = false;
            this.resultText = '';
            this.add_member_no = '';
            this.add_golf_groups = null;
            this.add_golf_courses = '';
            this.add_processing_date = '';
            this.add_select_point_types = '';
            this.add_action = null;
            this.add_point = null;
            this.add_point_value = null;
            this.add_comment = null;
            this.valid_start_disabled = true;
            this.valid_date_disabled = true;
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        search () {
            this.getPointList();
            this.getPointTotalFromMemberPointHistory();
        },
        /** ----------------------------------------------
         * ゴルフグループを取得
         * ---------------------------------------------- */
        getGolfGroup () {
            this.$apollo
                .mutate({
                    mutation: GET_GOLFGROUP,
                    variables: {}
                })
                .then(res => {
                    this.golf_groups = res.data.golfGroup;
                    this.golf_groups_val = res.data.golfGroup[0].golf_group_code;
                });
        },
        /** ----------------------------------------------
         * ポイント登録時、区分によって入力可能欄の切り替え
         * ---------------------------------------------- */
        pointTypeSelectDisabled () {
            if (this.add_select_point_types === '1') {
                this.limited_type_disabled = false;
                if (this.add_limited_type === '1') {
                    this.valid_start_disabled = true;
                    this.valid_date_disabled = true;
                } else if (this.add_limited_type === '2') {
                    this.valid_start_disabled = true;
                    this.valid_date_disabled = false;
                } else if (this.add_limited_type === '3') {
                    this.valid_start_disabled = false;
                    this.valid_date_disabled = false;
                }
            } else if (this.add_select_point_types === '2' || this.add_select_point_types === '3') {
                this.valid_start_disabled = true;
                this.valid_date_disabled = true;
                this.limited_type_disabled = true;
            }
        },
        /** ----------------------------------------------
         * ポイント登録
         * ---------------------------------------------- */
        addPoint () {
            if (this.$refs.form.validate()) {
                if (this.add_select_point_types === '2' || this.add_select_point_types === '3') {
                    this.add_point = -(this.add_point_value);
                    this.add_valid_start = null;
                    this.add_valid_date = null;
                } else if (this.add_limited_type === '1') {
                    this.add_valid_start = null;
                    this.add_valid_date = null;
                    this.add_point = this.add_point_value;
                } else if (this.add_limited_type === '2') {
                    this.add_valid_start = null;
                    this.add_point = this.add_point_value;
                } else if (this.add_select_point_types === '1' || this.add_limited_type === '3') {
                    this.add_point = this.add_point_value;
                }
                this.$apollo.mutate({
                    mutation: REGISTER_POINT,
                    variables: {
                        member_no: this.member_no,
                        golf_group_code: this.golf_groups_val,
                        golf_code: this.add_golf_courses,
                        processing_date: this.add_processing_date,
                        point_type: this.add_select_point_types,
                        point_flag: this.add_limited_type,
                        action: this.add_action,
                        point: this.add_point,
                        valid_start: this.add_valid_start,
                        valid_date: this.add_valid_date,
                        valid_flag: 1,
                        comment: this.add_comment,
                        limited_id: this.add_limited_id
                    }
                }).then(res => {
                    this.getPointList();
                    this.getPointTotalFromMemberPointHistory();
                    this.overlay = false;
                    this.add_golf_courses = null;
                    this.add_processing_date = '';
                    this.add_select_point_types = null;
                    this.add_limited_type = null;
                    this.add_action = null;
                    this.add_point_value = null;
                    this.add_valid_start = '';
                    this.add_valid_date = '';
                    this.add_comment = null;
                }).catch(error => {
                    this.result = 0;
                    this.resultText = this.$t('result.error.add');
                    this.error = error;
                });
            }
        },
        /** --------------------------------------------
         * ポイントがマイナス時のCSS切り替え
         * -------------------------------------------- */
        getColor (i) {
            if (i < 0) {
                return 'redselect';
            } else if (i > 0) {
                return 'blackselect';
            }
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpProcDate (event) {
            this.add_processing_date = this.formatDate(this.add_processing_date);
            this.add_processing_date = this.deleteKeyDelete(event);
        },
        deleteKeyUpValidStart (event) {
            this.add_valid_start = this.formatDate(this.add_valid_start);
            this.add_valid_start = this.deleteKeyDelete(event);
        },
        deleteKeyUpValidDate (event) {
            this.add_valid_date = this.formatDate(this.add_valid_date);
            this.add_valid_date = this.deleteKeyDelete(event);
        },
        /** --------------------------------------------
         * 期間限定の場合終了日が開始日より前日になっていないか
         * -------------------------------------------- */
        checkstartDate (enddate) {
            if (this.add_limited_type === '2' && !this.add_valid_start) {
                return true;
            } else if (this.add_limited_type === '3' && enddate) {
                var startdate = this.add_valid_start.replace(/-/g, '');
                startdate = Number(startdate);
                enddate = enddate.replace(/-/g, '');
                enddate = Number(enddate);
                if (startdate >= enddate) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        /** --------------------------------------------
         * 利用開始日のモーダルチェック
         * -------------------------------------------- */
        checkTypeStartDate (date) {
            if (this.add_select_point_types === '2' || this.add_select_point_types === '3' || !this.add_select_point_types) {
                return true;
            } else if (this.add_select_point_types === '1') {
                if ((this.add_limited_type === '3' && date === '') || (this.add_limited_type === '3' && date == null)) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        /** --------------------------------------------
         * 利用終了日のモーダルチェック
         * -------------------------------------------- */
        checkTypeEndDate (date) {
            if (this.add_select_point_types === '2' || this.add_select_point_types === '3' || !this.add_select_point_types) {
                return true;
            } else if (this.add_select_point_types === '1') {
                if ((this.add_limited_type === '2' && date === '') || (this.add_limited_type === '2' && date == null)) {
                    return false;
                } else if ((this.add_limited_type === '3' && date === '') || (this.add_limited_type === '3' && date == null)) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        /** --------------------------------------------
         * 区分非選択時の種類のモーダルチェック
         * -------------------------------------------- */
        checkTypelimited (value) {
            if (this.add_select_point_types === '2' || this.add_select_point_types === '3') {
                return true;
            } else if (this.add_select_point_types === '1' && !value) {
                return false;
            } else {
                return true;
            }
        },
        /** --------------------------------------------
         * ゴルフ場情報を取得
         * -------------------------------------------- */
        getGolfCourse: function () {
            for (var i = 0; i < this.golf_groups.length; i++) {
                if (this.golf_groups_val === this.golf_groups[i].golf_group_code) {
                    // ポイント利用区分がゴルフ場毎の場合、ゴルフ場情報を取得
                    if (this.golf_groups[i].point_use_type === 2) {
                        this.$apollo
                            .mutate({
                                mutation: GET_GOLFCOURSE,
                                variables: { golf_group_code: this.golf_groups_val }
                            })
                            .then(res => {
                                this.data = res.data.getGolfCourse;
                                this.golf_courses_val = this.data[0].golf_code;
                                for (var i = 0; i < this.data.length; i++) {
                                    this.golf_courses.push(this.data[i]);
                                }
                                this.golf_courses_disabled = false;
                            });
                        break;
                    } else {
                        this.golf_courses = [];
                        this.golf_courses_val = '';
                        this.golf_courses_disabled = true;
                    }
                }
            }
        },
        getGolfName: function () {
            this.$apollo
                .mutate({
                    mutation: GET_GOLFCOURSE,
                    variables: { golf_group_code: process.env.VUE_APP_GROUP_CODE }
                })
                .then(res => {
                    this.golf_select = res.data.getGolfCourse;
                    this.golf_courses_disabled = true;
                });
        },
        getGolfSearchName: function () {
            this.$apollo
                .mutate({
                    mutation: GET_GOLFCOURSE,
                    variables: { golf_group_code: process.env.VUE_APP_GROUP_CODE }
                })
                .then(res => {
                    this.golf_search = res.data.getGolfCourse;
                    if (this.golfGroupInfo[0].point_use_type === 1) {
                        this.golf_search.unshift({ golf_name: '全て', golf_code: '' });
                    }
                    this.golf_courses_disabled = true;
                });
        },
        /** ----------------------------------------------
         * ポイント履歴一覧を取得
         * ---------------------------------------------- */
        getPointList () {
            if (this.golf_groups_val && this.member_no) {
                this.$apollo
                    .mutate({
                        mutation: GET_POINT_LIST,
                        fetchPolicy: 'no-cache',
                        variables: {
                            member_no: this.member_no,
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golf_courses_val,
                            point_type: this.point_types_val,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows,
                            golf_name: this.golf_name,
                            valid_start: this.valid_start,
                            valid_date: this.valid_date,
                            comment: this.comment,
                            limited_id: this.limited_id,
                            display_flag: 0
                        }
                    })
                    .then(res => {
                        const count = res.data.getPointList.count;
                        this.pageCount = Math.ceil(count / 10);
                        this.desserts = res.data.getPointList.PointList;
                        if (this.desserts.length > 0) {
                            for (var i = 0; i < this.desserts.length; i++) {
                                if (this.desserts[i].point_flag) {
                                    for (var j = 0; j < this.limited_type.length; j++) {
                                        if (this.desserts[i].point_flag === parseInt(this.limited_type[j].code)) {
                                            this.desserts[i].point_flag_name = this.limited_type[j].code_name;
                                            break;
                                        }
                                    }
                                }
                                this.desserts[i].processing_date = this.desserts[i].processing_date.slice(0, 10);
                            }
                        }
                    });
            }
        },
        /** ----------------------------------------------
         * ポイント集計を取得
         * ---------------------------------------------- */
        getPointTotalFromMemberPointHistory () {
            this.$apollo.mutate({
                mutation: GET_POINT_TOTAL_FROM_MEMBER_POINT_HISTORY,
                fetchPolicy: 'no-cache',
                variables: {
                    member_no: this.member_no,
                    golf_group_code: this.golf_groups_val,
                    golf_code: this.golf_courses_val,
                    target_date: this.target_date
                }
            }).then(res => {
                if (res.data.getPointTotalFromMemberPointHistory.total_point) {
                    this.point_total = res.data.getPointTotalFromMemberPointHistory.total_point.total_all;
                    this.expected_total = res.data.getPointTotalFromMemberPointHistory.total_point.total_expected;
                } else {
                    this.point_total = 0;
                    this.expected_total = 0;
                }
            });
        },
        /** ----------------------------------------------
         * コードリスト取得
         * ---------------------------------------------- */
        getCodeList (keyname) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: keyname,
                    default_display: 0
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
         * ポイント区分取得
         * ---------------------------------------------- */
        getPointType () {
            return this.$apollo.query({
                query: GET_POINT_TYPE
            }).then(res => {
                return res.data.getPointType;
            });
        },
        /** ----------------------------------------------
         * 現在日付の取得
         * ---------------------------------------------- */
        getDateNow () {
            this.NowDate = new Date();
            this.NowDate.setDate(this.NowDate.getDate() - 1);
            this.add_processing_date = this.NowDate.getUTCFullYear() + '-' + ('0' + (this.NowDate.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + this.NowDate.getUTCDate()).slice(-2);
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                this.addOverlay = true;
            }
        },
        formSet () {
            this.form_display = true;
            this.getDateNow();
            this.overlay = true;
            if (this.golf_courses_val !== '') {
                this.add_golf_courses = this.golf_courses_val;
            } else {
                this.add_golf_courses = this.golfCourseInput;
            }
            if (this.form_display) {
                this.modeStatus = 'addpointlist';
                // インプットにフォーカスさせる処理
                this.$nextTick(() => {
                    // document.querySelector('.v-select__selections').focus();
                    document.getElementById('form_select').focus();
                });
            } else {
                this.modeStatus = '';
            }
        },
        formRemove () {
            this.modeStatus = '';
            this.form_display = false;
        },
        /** ----------------------------------------------
         * モーダル画面表示処理
         * @param val 表示制御値
         * @param memberNo 会員番号
         * ---------------------------------------------- */
        async ModalControl (val, memberNo, memberRank) {
            this.Initialize();
            this.member_rank = memberRank;
            this.member_no = memberNo;
            this.golf_groups_val = process.env.VUE_APP_GROUP_CODE;
            const today = new Date();
            const y = today.getFullYear();
            let m = today.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = today.getDate();
            d = d < 10 ? '0' + d : d;
            this.target_date = y + '-' + m + '-' + d;
            this.limited_type = await this.getCodeList('point_flag');
            this.getGolfName();
            await this.getGolfSearchName();
            if (this.golfCourseInput) {
                this.golf_courses_val = this.golfCourseInput;
            } else {
                this.golf_courses_val = '';
            }
            this.admin.user_id = this.adminInfo.user_id;
            this.getAuthorityList();
            this.getPointList();
            this.getPointTotalFromMemberPointHistory();
            let tempPointTypes = await this.getPointType();
            this.point_types = tempPointTypes.slice(0, tempPointTypes.length);
            this.point_types.unshift({ id: '', point_type_name: '全て', point_type_display: '全て' });
            this.add_point_types = tempPointTypes.slice(0, 1);
            this.dialog = val;
        },
        /** ----------------------------------------------
         * ポイント登録モーダル画面を閉じる際の初期化処理
         * ---------------------------------------------- */
        CloseAddModal () {
            this.overlay = false;
            this.add_golf_courses = null;
            this.add_processing_date = '';
            this.add_select_point_types = null;
            this.add_limited_type = null;
            this.add_action = null;
            this.add_point_value = null;
            this.add_valid_start = '';
            this.add_valid_date = '';
            this.add_comment = null;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.Initialize();
            this.$emit('refresh-event');
        },
        clickPagination () {
            this.begin_row = this.page * 10 - 10;
            this.getPointList();
        }
    }
};
</script>

<style>
.blackselect {
  color: black;
  background: Transparent;
}
.redselect {
  color: red;
  background-color: Transparent;
}
.table_space {
    padding-top: 25px;
    padding-left: 5px;
    padding-right: 5px;
}
.pointHistory__totalpoint{
    width: 100%;
    display: flex;
    text-align: right;
    flex-direction: column;
}
</style>
